import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import * as AWS from 'aws-sdk';

@Injectable({
    providedIn: 'root'
})
export class AWSService {
    // private s3: AWS.S3;

    constructor(private http: HttpClient) {}

    // Function to get the content type of an S3 object using a signed URL
    getContentypeFromSignedUrl(signedUrl: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.http.head(signedUrl, { observe: 'response' }).subscribe(data => {
                const contentType = data.headers.get('content-type'); // Get the content type from the blob object
                // You can use the content type as needed
            });
        });
    }

    downloadFile(url) {
        return this.http.get(url, {
            responseType: 'blob'
        });
    }
}
